<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="36"
		height="26"
		viewBox="0 0 36 26"
		fill="none"
	>
		<path
			d="M3.792 0.247 C 3.349 0.321,2.669 0.595,2.247 0.871 C 1.756 1.191,1.036 1.934,0.763 2.401 C 0.639 2.615,0.463 3.006,0.373 3.270 L 0.210 3.750 0.210 12.990 L 0.210 22.230 0.369 22.697 C 0.828 24.043,1.937 25.152,3.283 25.611 L 3.750 25.770 18.000 25.770 L 32.250 25.770 32.717 25.611 C 34.063 25.152,35.172 24.043,35.631 22.697 L 35.790 22.230 35.790 12.990 L 35.790 3.750 35.631 3.283 C 35.202 2.026,34.174 0.940,32.969 0.472 C 32.734 0.381,32.368 0.278,32.156 0.244 C 31.674 0.165,4.263 0.169,3.792 0.247 M32.232 2.710 C 32.668 2.915,33.085 3.332,33.290 3.768 C 33.447 4.103,33.450 4.139,33.468 5.475 L 33.486 6.839 20.529 6.855 L 7.571 6.870 7.344 7.053 C 6.943 7.378,6.870 7.521,6.870 7.979 C 6.870 8.339,6.892 8.421,7.050 8.644 C 7.149 8.785,7.338 8.956,7.470 9.025 L 7.710 9.150 20.595 9.166 L 33.480 9.181 33.479 15.466 L 33.477 21.750 33.337 22.091 C 33.071 22.737,32.538 23.227,31.920 23.392 C 31.713 23.447,28.455 23.460,17.850 23.447 L 4.050 23.430 3.750 23.280 C 3.341 23.076,2.906 22.629,2.711 22.214 L 2.550 21.870 2.534 13.082 C 2.517 3.399,2.493 4.053,2.888 3.457 C 3.119 3.109,3.455 2.841,3.889 2.663 L 4.230 2.522 18.060 2.536 L 31.890 2.550 32.232 2.710 "
			stroke="none"
			fill-rule="evenodd"
			fill="black"
		/>
	</svg>
</template>
